<template>

  <div class="container-fluid">

    <div class="row mb-2">
      <!--<h4>گزارش کار کارگاه ها (لطفا فیلتر مورد نظر خود را انتخاب کنید)</h4>-->
      <!--<div class="col-12 my-2 d-inline-flex">-->
      <!--<h6 class="pt-1">گزارش بر اساس کارهای کامل شده یا در حال انجام : </h6>-->
      <!--<toggle-button v-if="" class="mx-3" @change="btnClicked($event)" :value="isActive" color="#82C7EB" :width="100"-->
      <!--:height="25"-->
      <!--:sync="true"-->
      <!--:labels="{unchecked: 'کارهای کامل شده', checked: 'کارهای کامل شده'}"/>-->
      <!--</div>-->
      <!---------- PROGRAM ---------------------------------------------------------------------->
      <div v-if="isLoading" class="col-12 my-2 text-center">
        <Preloader/>
      </div>
      <div class="col-12 my-2" v-else>
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>انتخاب کد سفارش</span>
            </div>
          </div>
          <vs-select
            ref="selectedProgram"
            :isHeader="true"
            :data="orderCodes"
            :selectedVal="orderCodes.id"
            :header="{label:'name'}"
            :mode="'edit'"
            @dataChanged="orderSelect"
            aria-placeholder="لطفا کد سفارش را انتخاب کنید"
          ></vs-select>
          <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
        </div>
      </div>


      <div v-if="isLoading" class="col-12 my-2 text-center">
        <Preloader/>
      </div>
      <div class="col-12 my-2 text-center" v-else>
        <div v-if="nodata1">
          <h5>دستور تولید داده نشده است</h5>
        </div>
        <div v-else>
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">برنامه</th>
                <th scope="col" class="text-center">تاریخ برنامه</th>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">نام کارگاه</th>
                <th scope="col" class="text-center">تعداد کل</th>
                <th scope="col" class="text-center">تعداد تکمیل شده</th>
                <th scope="col" class="text-center">وضعیت فعلی</th>
                <th scope="col" class="text-center">زمان توقف در این وضعیت</th>
                <th scope="col" class="text-center">وضعیت قبلی</th>
                <th scope="col" class="text-center">توضیحات</th>
                <!--<th scope="col" class="text-center">مشاهده جرئیات</th>-->

              </tr>
              </thead>
              <tbody>
              <tr v-for="(it, ind) in prCodes">

                <td class="text-center">{{it.programCode}}</td>
                <td class="text-center">{{it.programfDate}}</td>
                <td class="text-center" colspan="8">
                  <table class="table table-striped">
                    <!--<thead>-->
                    <!--<tr>-->
                    <!--<th scope="col" class="text-center">نام محصول</th>-->
                    <!--<th scope="col" class="text-center">نام کارگاه</th>-->
                    <!--<th scope="col" class="text-center">تعداد کل</th>-->
                    <!--<th scope="col" class="text-center">تعداد تکمیل شده</th>-->
                    <!--<th scope="col" class="text-center">وضعیت فعلی</th>-->
                    <!--<th scope="col" class="text-center">زمان توقف در این وضعیت</th>-->
                    <!--<th scope="col" class="text-center">وضعیت قبلی</th>-->
                    <!--<th scope="col" class="text-center">توضیحات</th>-->
                    <!--&lt;!&ndash;<th scope="col" class="text-center">مشاهده جرئیات</th>&ndash;&gt;-->

                    <!--</tr>-->
                    <!--</thead>-->
                    <tbody>
                    <tr v-for="(item, index) in it.repProg">
                      <!--<th scope="row" class="text-center">{{item.id}}</th>-->
                      <td class="text-center">{{item.productName}}</td>
                      <td class="text-center">{{item.companyName}}</td>
                      <td class="text-center">{{item.workCount}}</td>
                      <td class="text-center">{{item.completedCount}}</td>
                      <td class="text-center">{{item.statusName}}</td>
                      <td class="text-center">{{item.hoursInStatus}}</td>
                      <table class="table table-striped">
                        <tbody>
                        <tr v-if="item.lastStatus.length !=0" v-for="(item2, index2) in item.lastStatus">
                          <!--<th scope="row" class="text-center">{{item.id}}</th>-->
                          <td class="text-center">{{item2.statusName}}</td>
                          <td class="text-center">{{item2.hoursInStatus}}</td>
                        </tr>
                        <tr v-else class="text-center">---</tr>
                        </tbody>
                      </table>
                      <td class="text-center">{{item.description}}</td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>


              <!--<tr v-for="(item, index) in reportProgram">-->

              <!--<td class="text-center">{{item.programCode}}</td>-->
              <!--<td class="text-center">{{item.programfDate}}</td>-->

              <!--<td class="text-center">{{item.productName}}</td>-->
              <!--<td class="text-center">{{item.companyName}}</td>-->
              <!--<td class="text-center">{{item.workCount}}</td>-->
              <!--<td class="text-center">{{item.completedCount}}</td>-->
              <!--<td class="text-center">{{item.statusName}}</td>-->
              <!--<td class="text-center">{{item.hoursInStatus}}</td>-->
              <!--<table class="table table-striped">-->
              <!--<tbody>-->
              <!--<tr v-if="item.lastStatus.length !=0" v-for="(item2, index2) in item.lastStatus">-->
              <!--&lt;!&ndash;<th scope="row" class="text-center">{{item.id}}</th>&ndash;&gt;-->
              <!--<td class="text-center">{{item2.statusName}}</td>-->
              <!--<td class="text-center">{{item2.hoursInStatus}}</td>-->
              <!--</tr>-->
              <!--<tr v-else class="text-center">-&#45;&#45;</tr>-->
              <!--</tbody>-->
              <!--</table>-->
              <!--<td class="text-center">{{item.description}}</td>-->
              <!--&lt;!&ndash;<td class="text-center">&ndash;&gt;-->
              <!--&lt;!&ndash;<button class="btn btn-success mx-2 " @click="btnDetail(item)"><i class="icon-content-duplicate"></i>&ndash;&gt;-->
              <!--&lt;!&ndash;</button>&ndash;&gt;-->
              <!--&lt;!&ndash;</td>&ndash;&gt;-->
              <!--</tr>-->
              </tbody>
            </table>
          </div>

        </div>
      </div>
      <!---------- PROGRAM ---------------------------------------------------------------------->

    </div>


    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="detail-modal"
      id="detailModal"
      size="xl"
      title="جزئیات کار"
      ok-title="بستن"
      ok-only
      @hide="resetFlowchartFlag"
    >

      <div class="flowchart">

        <div class="row">
          <div class="col-2 mt-3">
            <div class="col mt-1">
              <span class="badge badge-warning" style="background-color: #FF8F00; font-size: 10px;">درصف انتظار</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-success" style="background-color: #9E9D24; color: black; font-size: 10px">درحال انجام</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-success" style="background-color: #2E7D32; font-size: 10px">تکمیل شده</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-info text-white"
                    style="background-color: #0277BD; font-size: 10px;">تایید شده</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-primary" style="background-color: #deddff; font-size: 10px">غیرفعال</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-danger" style="background-color: #c62828; font-size: 10px">مشکل</span>
            </div>
          </div>
          <div class="col-10 d-flex align-items-center">
            <work-flowchart ref="flowchart" :works="innerWorkDetails"></work-flowchart>
          </div>
        </div>
      </div>
    </b-modal>

  </div>


</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import ToggleButton from "vue-js-toggle-button/src/Button";
  import VsSelect from "../../_framework/VsSelect";
  import WorkChart from "../../components/WorkChart.vue";
  import WorkStatus from "../../components/WorkStatus.vue";
  import WorkFlowchart from "../../components/WorkFlowchart.vue";
  import Moment from 'moment-jalali';

  export default {
    name: "allcompanyproducts",
    created: () => {
    },
    components: {
      VsTable,
      Products,
      ToggleButton,
      VsSelect,
      WorkChart,
      WorkStatus,
      WorkFlowchart,
      Moment,
    },
    data() {
      return {
        isLoading: false,
        isActive: false,
        isActiveInt: 2,
        nodata1: true,
        nodata2: true,
        isPorog: false,
        isOrder: false,
        isManual: false,
        programCodes: [],
        orderCodes: [],
        manualCodes: [],
        reportProgram: [],

        reportType: [
          {id: 1, name: "گزارش بر اساس کد برنامه "},
          {id: 2, name: "گزارش بر اساس کد سفارش "},
          {id: 3, name: "گزارش بر اساس کد دستور تولید "},
        ],
        programSelsected: 0,
        orderSelsected: 0,
        manualSelsected: "a",
        innerWorkDetails: {},
        workDetail: [],
        productId: 0,
        prCodes: [{
          programCode: 0,
          programfDate: "",
          repProg: []
        }
        ],
      };
    },
    beforeMount() {
      this.getProgramCodes();
      this.getOrderCodes();
      this.getManualCodes();
    },
    methods: {
      btnClicked(e) {
        // console.log(e);
        // console.log(this.isActive);
        if (this.isActive === true) {
          this.isActive = false;
          this.isActiveInt = 0;
        } else {
          this.isActive = true;
          this.isActiveInt = 1;
        }
        // console.log(this.isActive);
      },
      getProgramCodes() {
        new BaseService('Planning', '/GetAllProgramCode/true').getList().then((response) => {
          this.programCodes = response.data;
          if (this.programCodes.length > 0) {
            for (let i = 0; i < this.programCodes.length; i++) {
              this.programCodes[i].name = "برنامه کد " + this.programCodes[i].programCode + " کالای " + this.programCodes[i].productName + " تعداد " + this.programCodes[i].count + " باقیمانده " + (this.programCodes[i].count - this.programCodes[i].completed);
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getOrderCodes() {
        var param = {
          type: 1,
          pageIndex: 0,
          pageSize: 100
        };
        this.isLoading = true;
        new BaseService('orders').getList(param).then((response) => {
          var orderCod = response.data.data;
          var pp = 0;
          if (orderCod.length > 0) {
            for (let i of orderCod) {
              // if (i.serveCompanyId != null) {
              var data = {
                name: "کد سفارش : " + i.code + " کالای " + i.orders[0].productName + " تعداد " + i.orders[0].unitId,
                id: i.id
              };
              this.orderCodes.push(data);
              // }
            }
          }
          // console.log(this.orderCodes)  ;
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      getManualCodes() {
        new BaseService('WorksReports', '/GetManualCods').getList().then((response) => {
          this.manualCodes = response.data;
          if (this.manualCodes.length > 0) {

            for (let item of this.manualCodes) {
              item.id += 1;
              item.name = item.productOrderCode + " / " + item.code + " / " + item.description;
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      typeSelect(prop, data) {
        switch (data.id) {
          case 1:
            this.isPorog = true;
            this.isOrder = false;
            this.isManual = false;
            break;
          case 2:
            this.isPorog = false;
            this.isOrder = true;
            this.isManual = false;
            break;
          case 3:
            this.isPorog = false;
            this.isOrder = false;
            this.isManual = true;
            break;
        }
      },
      programSelect(prop, data) {
        this.programSelsected = data.programId;
        this.orderSelsected = 0;
        this.manualSelsected = "a";
        this.productId = data.productId;
        this.getReportProgram();
      },
      orderSelect(prop, data) {
        this.programSelsected = 0;
        this.orderSelsected = data.id;
        this.manualSelsected = "a";
        this.getReportProgram();
      },
      manualSelect(prop, data) {
        console.log(data)
        this.programSelsected = 0;
        this.orderSelsected = 0;
        this.manualSelsected = data.productOrderCode;
        this.getReportProgram();
      },
      getReportProgram() {
        this.isLoading = true;
        new BaseService('WorksReports', '/GetTotalWorkReport/' + this.programSelsected + '/' + this.orderSelsected + '/' + this.manualSelsected + '/' + this.isActiveInt + '/' + this.productId).getList().then((response) => {
            let a;
            this.isLoading = false;

            // console.log(response.data);
            this.nodata1 = false;
            this.nodata2 = false;
            if (response.data === null || response.data === "") {
              this.nodata1 = true;
            } else {
              this.reportProgram = response.data;
              if (this.reportProgram.length === 0) {
                this.nodata1 = true;
              } else {
                this.nodata1 = false;
                this.prCodes = [];

                for (let item of this.reportProgram) {
                  item.programfDate = Moment(item.programDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");
                  if (this.prCodes.length > 0) {
                    let fi = false;
                    for (let i of this.prCodes) {
                      if (i.programCode === item.programCode) {
                        fi = true;
                      }
                    }
                    if (!fi) {
                      a = {
                        programCode: item.programCode,
                        programfDate: item.programfDate,
                        repProg: []
                      };
                      this.prCodes.push(a);
                    }
                  }
                  else {
                    a = {
                      programCode: item.programCode,
                      programfDate: item.programfDate,
                      repProg: []
                    };
                    this.prCodes.push(a);
                  }
                  if (item.status === 4) {
                    item.hoursInStatus = "---";
                  }
                  switch (item.status) {
                    case 0 :
                      item.statusName = "در انتظار";
                      break;
                    case 1 :
                      item.statusName = "متوقف";
                      break;
                    case 2 :
                      item.statusName = "در حال تولید";
                      break;
                    case 3 :
                      item.statusName = "تولید شده";
                      break;
                    case 4 :
                      item.statusName = "تائید شده";
                      break;
                  }
                  if (item.lastStatus.length !== 0) {
                    for (let item2 of item.lastStatus) {

                      switch (item2.status) {
                        case 0 :
                          item2.statusName = "در انتظار";
                          break;
                        case 1 :
                          item2.statusName = "متوقف";
                          break;
                        case 2 :
                          item2.statusName = "در حال تولید";
                          break;
                        case 3 :
                          item2.statusName = "تولید شده";
                          break;
                        case 4 :
                          item2.statusName = "تائید شده";
                          break;
                      }
                    }
                  }

                }

                console.log(this.prCodes)
                for (let i of this.prCodes) {
                  for (let j of this.reportProgram) {
                    if (i.programCode === j.programCode) {
                      i.repProg.push(j)
                    }
                  }
                }
              }
            }
          }
        ).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      btnDetail(item) {
        // console.log("clike")


        this.$refs['detail-modal'].show()
        this.getOrderDetail(item.workId);
      }
      ,
      getOrderDetail(workId) {
        // console.log(workId)
        new BaseService('WorksReports', '/GetOrderDetailWorks/' + workId).getList().then((response) => {
          // setTimeout(() => {
          //   console.log("sss")
          //   // if (this.$refs.flowchart !== undefined) {
          //   // console.log("ssssdssdds")
          this.$refs.flowchart.getFlowchartDetail(response.data);
          //   // }
          // }, 10)
          //   console.log(response.data)
          this.innerWorkDetails = response.data;
          this.workDetail = this.innerWorkDetails.works;
        }).catch((error) => {
          console.log(error)
        })
      }
      ,
      resetFlowchartFlag() {
        this.$refs['detail-modal'].hide();
      }
      ,
    },
    computed: {
      ...
        mapState(["vsTableFeed", "tableRowIndex"])
    }
  }
  ;
</script>
